import React from "react";
import { Country as CountryStateCity } from "country-state-city";

const CountrySelector = ({ selectedCountry, onSelectCountry }) => {
  const handleCountryChange = (event) => {
    onSelectCountry(event.target.value);
  };

  return (
    <div className="text-xs">
      <select
        id="country"
        value={selectedCountry}
        onChange={handleCountryChange}
        className="p-2 border rounded-md focus:outline-none focus:ring-0"
      >
        <option value="" disabled>
          Select Country
        </option>
        {CountryStateCity.getAllCountries().map((country, index) => (
          <option key={index} value={country.name}>
            {country.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountrySelector;
